import { isRTLLocale } from 'garaje/utils/locale-options';

/**
 * @param {String}           locale
 */
export default isRTLLocale;
